export type {
  Applicant as ServiceApplicant,
  Organization as ServiceApplicantOrganization,
} from '../generated/contract';
export type {
  CreationRequest as ServiceApplicationRequest,
  Response as ServiceApplicationResult,
} from '../generated/contract';
export type { EntitlementsResponse, Service as EntitlementService } from '../generated/contract';

export { GetEntitlementsServiceTypeEnum as EntitlementServiceType } from '../generated/contract';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useGuardedMutation as useMutation } from '../../hooks/useGuardedMutation';
import { API_CONFIG } from '../config/env';
import {
  CreationRequest,
  EntitlementControllerApi,
  EntitlementsResponse,
  GetEntitlementsServiceTypeEnum,
  Response as ApplyResponse,
  ServiceApplicationControllerApi,
} from '../generated/contract';
import { QK_CONTRACT_ENTITLEMENTS } from '../query-keys';

const CONTRACT_URL = API_CONFIG.CONTRACT_URL;
const entitlementControllerApi = new EntitlementControllerApi(undefined, CONTRACT_URL);
const serviceApplicationControllerApi = new ServiceApplicationControllerApi(undefined, CONTRACT_URL);

// 기관은 토큰에서 유도된다. 와이브레인 직원 토큰으로는 403 이다.
export const useFetchEntitlements = (serviceType?: GetEntitlementsServiceTypeEnum) => {
  return useQuery<EntitlementsResponse>({
    queryKey: [QK_CONTRACT_ENTITLEMENTS, serviceType],
    queryFn: () => entitlementControllerApi.getEntitlements(serviceType).then((res) => res.data),
  });
};

/**
 * 같은 계약에 같은 termsVersion 기록이 이미 있으면 409 이며, 이는 「이미 접수 완료」를 뜻한다.
 *
 * 접수되면 자격 판정이 바뀌지만 여기서 무효화하지 않는다. 판정이 바뀌는 순간 호출하는 화면의
 * 분기가 바뀌어 접수 완료 안내가 언마운트되기 때문이다. 무효화는 안내를 끝낸 호출부가 한다.
 */
export const useApplyServiceApplication = () =>
  useMutation<ApplyResponse, AxiosError, CreationRequest>({
    networkMode: 'always',
    mutationFn: (value) => serviceApplicationControllerApi.apply(value).then((res) => res.data),
  });
